
import Stack from "@mui/material/Stack";
import Button from '@mui/material/Button';
import "../Styles/forgetpassword.css"


export default function NextButton(props) {

  const handleOnClick = () => {
    props.handleOnClick();
  };

  return (
    <Stack spacing={2} direction="row">
      <Button
        onClick={handleOnClick}             
        variant="contained"
        data-testid={props.testid}
        className={`button ${props.class}`}
      >
        {props.text}
      </Button>
    </Stack>
  );
}
